<ng-container *transloco="let t">
  @if (data() && columns()!.length) {
    <ui-table
      [dataSource]="dataWithId()"
      [columns]="columns()"
      [columnTemplates]="columnTemplates"
      [scrollConfig]="scrollConfig()"
      [pageSize]="pageSize()"
      [pageIndex]="pageIndex()"
      [showPagination]="showPagination()"
      [showPageSizeChanger]="showPageSizeChanger()"
      [total]="total()"
      [showTotal]="total() ? totalTemplate : null"
      [loading]="loading()"
      [frontPagination]="false"
      (onQueryParams)="onQueryParamsChange($event)"
    />
  }

  <ng-template #transformerTemplate let-data let-row="row">
    <ui-rsabt-indicator
      [state]="data?.state"
      [showCenterCode]="showCenterCode()"
      [name]="data?.name"
      [id]="data?.id"
      [distributorR1]="data?.r1"
      [distributorId]="row.distributorId"
      [rsabtId]="row.rsabtId"
      [transformerId]="row.transformerId"
      [centerId]="row.centerId"
      [vtnId]="row.vtnId"
      (onCenter)="emitCenter($event)"
    />
  </ng-template>

  <ng-template #centerTemplate let-data let-row="row">
    <ui-center-indicator
      [state]="data?.state"
      [indicators]="data?.transformers"
      [centerName]="data?.centerName"
      [centerId]="row.centerId"
      [distributorId]="row.distributorId"
      [rsabtId]="row.rsabtId"
      [vtnId]="row.vtnId"
      (onRsabt)="emitRsabtId($event)"
      (onCenter)="emitCenter($event)"
    />
  </ng-template>

  <ng-template #outputsBtTemplate let-data let-row="row">
    <ui-outputs-bt-indicator
      [state]="data?.state"
      [indicators]="data?.outputBt"
    />
  </ng-template>

  <ng-template #intensityTemplate let-data let-row="row">
    <ui-intensity-indicator
      [state]="data.state"
      [nominal]="data?.nominal"
      [percentage]="data?.percentage"
      [intensity]="data?.intensity"
    />
  </ng-template>

  <ng-template #powerTemplate let-data let-row="row">
    <ui-power-indicator
      [state]="data.state"
      [nominal]="data?.nominal"
      [percentage]="data?.percentage"
      [power]="data?.power"
    />
  </ng-template>

  <ng-template #waveQualityTemplate let-data let-row="row">
    <ui-wave-quality-indicator
      [state]="data.state"
      [isSignalHealthy]="data?.waveStatus"
    />
  </ng-template>

  <ng-template #temperatureTemplate let-data let-row="row">
    <ui-temperature-indicator
      [state]="data.state"
      [temperature]="data?.temperature"
    />
  </ng-template>

  <ng-template #statusUpdateTemplate let-data let-row="row">
    <ui-status-update-indicator
      [state]="data.state"
      [timestamp]="data?.timestamp"
      [isSignalHealthy]="data?.isSignalHealthy"
    />
  </ng-template>

  <ng-template #actionsTemplate let-data let-row="row">
    @if(hasReadPermission()){
      <div class="flex justify-center">
        <ui-icon
          uiTooltip
          [tooltipTitle]="toolTipTemplate"
          [icon]="'setting'"
          [theme]="'outline'"
          class="cursor-pointer hover:opacity-70"
          style="color: #262626; font-size: 16px;"
          (click)="onSettingsClick(row)">
        </ui-icon>
      </div>
    }
  </ng-template>

  <ng-template #toolTipTemplate>
    <div class="flex flex-col items-center text-xs mt-0.5">
      <span> {{ t('ACTIONS.CONFIGURATION') }}</span>
    </div>
  </ng-template>

  <ng-template #totalTemplate>
    {{ total() | translocoDecimal }}
    {{ t('DISTRIBUTION_NETWORK.TABLE.RESULTS') }}
  </ng-template>
</ng-container>
